// extracted by mini-css-extract-plugin
module.exports = {"infiniteScrollLoader":"styles_infiniteScrollLoader__31l80","infiniteCollectPage":"styles_infiniteCollectPage__24PMW"};